(function () {
    "use strict";

    angular
        .module("app")
        .directive("customerSearchHelp", ["SearchFactory", customerSearchHelp]);

    function customerSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.customerKey = "";
                        scope.customerName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.customerName === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.customerSearch(function (customer) {
                        scope.customerKey = customer ? customer.CustomerKey : "";
                        scope.customerName = customer ? customer.CustomerName : "";
                        scope.displayValue = scope.customerDesc;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.$watch("customerName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.customerName;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { customerKey: "=", customerName: "=", readOnly: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

